import { captureError } from "./sentry";

const isProd = import.meta.env.PROD;

function normalizeError(err: unknown): Error {
  if (err instanceof Error) return err;
  return new Error(typeof err === "string" ? err : JSON.stringify(err));
}

export const logger = {
  debug(msg: string, ctx?: Record<string, unknown>) {
    if (!isProd) console.log(`[DEBUG] ${msg}`, ctx ?? "");
  },

  info(msg: string, ctx?: Record<string, unknown>) {
    if (!isProd) console.info(`[INFO] ${msg}`, ctx ?? "");
  },

  warn(msg: string, ctx?: Record<string, unknown>) {
    if (!isProd) console.warn(`[WARN] ${msg}`, ctx ?? "");
  },

  error(msg: string, err?: unknown, ctx?: Record<string, unknown>) {
    if (!isProd) {
      console.error(`[ERROR] ${msg}`, err, ctx ?? "");
    } else {
      captureError(normalizeError(err ?? msg), { message: msg, ...ctx });
    }
  },
};
